/* eslint-disable react-hooks/rules-of-hooks */
import React, { memo, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import styles from "./index.module.css";
import demo from "./../../asset/img/indiba_animal.jpeg";
import tel from "./../../asset/img/tel.png";
import addMorePng from "./../../asset/img/add-more.png";
import warningPNG from "./../../asset/img/warning.png";
import { fileUrl, swiperDefault } from "../../const";
import { getURLparmas } from "../../utils";
import { fetchEquipInfo, login } from "../../api/api";
import { DoubleRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const Equipment = memo(function index() {
  const [details, setDetails] = useState<any>(null);
  const history = useHistory();

  useEffect(() => {
    const informationBaseId = getURLparmas("informationBaseId"); // ba10b9f7-b2dd-4a69-8ba7-e0359f6caded
    if (!informationBaseId) return;
    login({ username: "system", password: "qwert@12345!" }).then((res: any) => {
      if (res && res.code === 200) {
        localStorage.setItem("token", res.data);
        fetchEquipInfo(informationBaseId).then((resInfo: any) => {
          if (resInfo && resInfo.code === 200) {
            console.log("info", resInfo.data);
            setDetails(resInfo.data);
            // document.title = resInfo.data.F_FullName;
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    if (details) {
      const height = document.getElementById("equipmentInner")?.offsetHeight;
      const equipmentPageRef = document.getElementById("equipmentPage");
      if (equipmentPageRef && height) {
        equipmentPageRef.style.height = height + 40 + "px";
      }
    }
  }, [details]);

  /** 更多注意事项 */
  const handleMore = () => {
    history.push("/attentionMore");
  };

  if (!details)
    return (
      <div className="loading-store">
        <LoadingOutlined />
      </div>
    );

  return (
    <div className={styles.wrapper} id="equipmentPage">
      <div className={styles.headBg}>
        <div id="equipmentInner">
          <div className={styles.equipImg}>
            <img
              src={`${fileUrl}/${details.F_HeadImgPath}` || demo}
              alt="设备照片"
            />
          </div>
          <div className={styles.content}>
            <div className={styles.contentInner}>
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>店铺所在地</div>
                <div className={styles.contentItemNameEn}>Store location</div>
                <div className={styles.contentItemValue}>
                  {details.F_CompanyAddress || "-"}
                </div>
              </div>
              {/* <div className={styles.contentItem}>
                <div className={styles.contentItemName}>店铺地址</div>
                <div className={styles.contentItemNameEn}>Store address</div>
                <div className={styles.contentItemValue}>
                  {details.F_ShippingAddress || '-'}
                </div>
              </div> */}
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>设备持有人</div>
                <div className={styles.contentItemNameEn}>Equipment holder</div>
                <div className={styles.contentItemValue}>
                  {details.F_CompanyName || "-"}
                </div>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>认证序号</div>
                <div className={styles.contentItemNameEn}>Certification</div>
                <div className={styles.contentItemValue}>
                  {details.F_IdNum || "-"}
                </div>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>设备编码</div>
                <div className={styles.contentItemNameEn}>Equipment code</div>
                <div className={styles.contentItemValue}>
                  {details.F_ProductNum || "-"}
                </div>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>设备型号</div>
                <div className={styles.contentItemNameEn}>Equipment model</div>
                <div className={styles.contentItemValue}>
                  {details.F_Model || "-"}
                </div>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>店铺负责人</div>
                <div className={styles.contentItemNameEn}>person in charge</div>
                <div className={styles.contentItemValue}>
                  {details.F_CompanyLeader || "-"}
                </div>
              </div>
              <div className={styles.contentItem}>
                <div className={styles.contentItemName}>店铺联系方式</div>
                <div className={styles.contentItemNameEn}>contact</div>
                <div className={`${styles.contentItemValue} ${styles.tel}`}>
                  <div>{details.F_CompanyTel || "-"}</div>
                  <div>
                    <a href={`tel:${details.F_CompanyTel}`}>
                      <img style={{ width: "16px" }} src={tel} alt="电话" />
                    </a>
                  </div>
                </div>
              </div>
              <div
                className={styles.footer}
                onClick={() =>
                  (window.location.href = "http://www.indibachn.com")
                }
              >
                <div>更多信息请点击查看官网</div>
                <div>More information click the official website</div>
                <img src={addMorePng} alt="more" />
              </div>
            </div>
          </div>
          <div className={styles.store}>
            <div className={styles.storeTitle}>店铺照片</div>
            <div className={styles.swiperWrap}>
              <Swiper
                spaceBetween={0}
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                autoplay={{
                  delay: 3000,
                  stopOnLastSlide: false,
                  disableOnInteraction: true,
                }}
                slidesPerView={1}
                loop={true}
              >
                {(details?.F_ImgPath
                  ? details.F_ImgPath.split(",")
                  : swiperDefault
                ).map((item: any, index: React.Key | null | undefined) => (
                  <SwiperSlide key={index}>
                    <img
                      className="swiper-store"
                      src={`${fileUrl}/${item}`}
                      alt=""
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
          <div className={styles.lookout}>
            <div className={styles.lookoutTitle}>
              <img src={warningPNG} alt="注意" />
              <span className={styles.look}>注意事项</span>
              <span>Notices</span>
            </div>
            <div className={styles.textZh}>
              <p>
                INDIBA®英特波®全系列设备均应由完成并已通过INDIBA®英特波®认证培训课程的专业人员使用。
              </p>
              <p>
                已通过INDIBA®英特波®认证培训课程的人员拥有我司颁发的认证工牌，通过工牌上的二维码可见经过认证学员的信息。
              </p>
              <div className={styles.textZhMore} onClick={handleMore}>
                点击查看更多 <DoubleRightOutlined />
              </div>
            </div>
            {/* <div className={styles.textEh}>
            InDIBA ® Intebo ® full range of equipment should be used by professionals who have completed and have passed the INDIBA ® Interbo ® certification training courses.
People who have passed inDIBA® Interbo ® certification training courses have the certification plate issued by our company, and the information of certified students can be seen through the two-dimensional code on the work card.
            </div> */}
            <div className={styles.afterSale}>
              <div>
                <div>售后电话</div>
                <div>Contact</div>
              </div>
              <div>
                <span>请联系</span>
                <a href="tel:010-85951853">
                  4000067956 <img width={"16px"} src={tel} alt="电话" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export { Equipment };
